import { createAction, props } from "@ngrx/store";
import { CustomerDto } from "../interfaces/customer_dto";
import { PurchasesEntitlementInfos } from "@revenuecat/purchases-capacitor";
import { EntitlementInfos } from "@revenuecat/purchases-js";

export const loadCustomer = createAction(
    "[Customer] Load Customer"
);

export const loadCustomerSuccess = createAction(
    "[Customer] Load Customer Success",
    props<{ customer: CustomerDto }>()
);

export const loadClaimsSuccess = createAction(
    "[Customer] Load Claims Success",
    props<{ claims: any }>()
);

export const updateCustomer = createAction(
    "[Customer] Update Customer",
    props<{ customer: CustomerDto }>()
);

export const updateCustomerSuccess = createAction(
    "[Customer] Update Customer Success",
    props<{ customer: CustomerDto }>()
);

export const updateCustomerEntitlements = createAction(
    "[Customer] Update Customer Entitlements",
    props<{ entitlements: string[] }>()
);

export const updateCustomerPlatformPurchase = createAction(
    "[Customer] Update Customer Platform Purchase",
    props<{ platformPurchase: string }>()
);